var __jsx = React.createElement;
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import i18next from "i18next";
var LocationSearchComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.LocationSearch;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var LocationSearchPage = function LocationSearchPage() {
  var store = useStore();
  useEffect(function () {
    store.initComponent("LocationSearch").then(function () {
      // NOOP
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.location_search.pagetitle", {
    defaultValue: "Restaurant Locations"
  }))), __jsx(LocationSearchComp, null));
};
LocationSearchPage.layout = PageLayout.NB_LAYOUT;
LocationSearchPage.layoutProps = {
  analyticsData: {
    pageName: "locations location-search",
    pageType: "locations location-search",
    productCategoryPageType: "Location Search"
  }
};
export default observer(LocationSearchPage);